import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MarketingNav } from "@/components/Marketing";
import TimelineRenderer from "@/components/timeline/TimelineRenderer";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { GitCompare } from "lucide-react";

const Column = ({ options, value, onChange, tl }) => (
  <div className="flex-1 min-w-0 border-r border-border last:border-r-0">
    <div className="sticky top-16 z-20 glass p-3 border-b border-border">
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid="compare-select"><SelectValue placeholder="Choose a timeline…" /></SelectTrigger>
        <SelectContent>
          {options.map((o) => <SelectItem key={o.id} value={`${o.creator_username}|${o.slug}`}>{o.title}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
    <div className="h-[calc(100vh-8.5rem)] overflow-y-auto">
      {tl ? <TimelineRenderer timeline={{ ...tl, layout: "vertical" }} /> : (
        <div className="h-full grid place-items-center text-muted-foreground text-sm px-6 text-center">Pick a timeline to compare</div>
      )}
    </div>
  </div>
);

export default function Compare() {
  const [params] = useSearchParams();
  const [options, setOptions] = useState([]);
  const [a, setA] = useState(null);
  const [b, setB] = useState(null);
  const [tlA, setTlA] = useState(null);
  const [tlB, setTlB] = useState(null);

  useEffect(() => { (async () => { const { data } = await api.get("/discover"); setOptions(data); })(); }, []);

  const fetchTl = async (val, set) => {
    if (!val) return set(null);
    const [u, s] = val.split("|");
    try { const { data } = await api.get(`/public/${u}/${s}`); set(data); } catch { set(null); }
  };
  useEffect(() => { fetchTl(a, setTlA); }, [a]);
  useEffect(() => { fetchTl(b, setTlB); }, [b]);

  return (
    <div className="bg-background min-h-screen flex flex-col">
      <MarketingNav />
      <div className="max-w-7xl mx-auto w-full px-5 sm:px-8 pt-8 pb-4">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-primary mb-3"><GitCompare size={14} /> Compare Mode</div>
        <h1 className="font-display text-4xl font-semibold tracking-tight text-foreground">Two timelines, side by side</h1>
        <p className="mt-2 text-muted-foreground">Compare any two published timelines on parallel tracks — Apple vs Microsoft, WWI vs WWII, plan vs execution.</p>
      </div>
      <div className="flex-1 flex border-t border-border">
        <Column options={options} value={a} onChange={setA} tl={tlA} />
        <Column options={options} value={b} onChange={setB} tl={tlB} />
      </div>
    </div>
  );
}
